const DangerIcon = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.5 6.05761V9.16801M8.5 12.2784H8.50731M7.48814 2.08542L1.47781 13.1325C1.14444 13.7452 0.97775 14.0516 1.00239 14.303C1.02387 14.5224 1.13186 14.7217 1.29946 14.8513C1.49162 15 1.8243 15 2.48967 15H14.5103C15.1757 15 15.5084 15 15.7005 14.8513C15.8681 14.7217 15.9761 14.5224 15.9976 14.303C16.0222 14.0516 15.8556 13.7452 15.5222 13.1325L9.51186 2.08542C9.17968 1.47488 9.01359 1.1696 8.7969 1.06708C8.60789 0.977641 8.39211 0.977641 8.2031 1.06708C7.98641 1.1696 7.82032 1.47488 7.48814 2.08542Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DangerIcon;
